import { EventHandler } from '@nolimitcity/slot-game/bin/core/event/EventHandler';
import { FreespinIntroController } from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";

export class BFFreespinIntroController extends FreespinIntroController {

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, "START_FREE_SPIN_INTRO", () => this.start());
    }
}